import moment from "moment";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { processJonham } from "../../helpers";

import "./index.css";

class Origins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrigin: 0,
      origins: null,
    };

    axios
      .get("/api/origin")
      .then((res) => {
        this.setState({
          origins: res.data,
        });
      })
      .catch();
  }

  componentDidMount() {
    const array = ["Kp", "En", "Cn", "Ru"];
    // console.log(this.props.language);
    axios
      .post(`/api/log`, {
        title: "원산지명",
        lang: array[this.props.language],
        type: "기사",
      })
      .then((res) => {
        // setMarks(res.data);
        // console.log(res.data);
      })
      .catch();
  }

  handleClick(index) {
    this.setState({ selectedOrigin: index });
  }

  render() {
    const {
      introLabel,
      originLabel,
      originNameLabel,
      rDateLabel,
      rImageLabel,
      rNumberLabel,
      rOrgLabel,
      rVideoLabel,
    } = this.props.labels;

    const { selectedOrigin } = this.state;

    const array = ["Kp", "En", "Cn", "Ru"];
    const origins = this.state.origins;

    const language = this.props.language;
    const search = this.props.search;

    if (!origins || origins.length === 0) return <></>;

    let data = origins[selectedOrigin];
    if (!data) return <></>;

    if (!data.imageUrls) data.imageUrls = [];

    const markHighLight = (str, keyword) => {
      const patt = new RegExp(keyword, "g");
      if (str != "" && str !== null && str !== undefined && keyword !== "") {
        return str.replace(patt, `<mark>${keyword}</mark>`);
      } else if (keyword !== "" && (str === null || str === undefined)) {
        return "";
      } else if (keyword === "" && (str === null || str === undefined)) {
        return "";
      } else if (keyword === "") {
        return str;
      }
    };

    return (
      <div className="origin-root">
        <div className="origins container d-flex">
          <div className="pt-5 sidebar">
            {origins.map((origin, index) => {
              return (
                <div
                  key={index}
                  className={classnames(
                    "pointer pt-2 pt-sm-2 pt-md-3 pt-lg-4 pr-sm-1 pr-md-2 pr-lg-3 pb-3 pb-sm-3 pb-md-4 pb-lg-5 pl-4 pl-sm-4 pl-md-4 pl-lg-5 tab",
                    index === selectedOrigin ? "active" : ""
                  )}
                  onClick={() => this.handleClick(index)}
                >
                  {origin[`name${array[language]}`]}
                </div>
              );
            })}
          </div>
          <div
            className="py-5 px-2 px-sm-2 px-md-3 px-lg-5 content"
            style={{
              backgroundImage:
                data.bgImage && data.bgImage.length > 0
                  ? `url('uploads/origin/${data.bgImage[0]}')`
                  : "",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <img
                  src={`uploads/origin/${data.imageUrl}`}
                  // className="border-1-red"
                  alt={data.imageUrl}
                  style={{ width: "100%", height: "200px" }}
                />
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 mt-sm-2 md-md-2">
                <div className="py-1">
                  <b>{originNameLabel[language]}</b> :{" "}
                  <span
                    className="h5"
                    style={{ color: "red" }}
                    dangerouslySetInnerHTML={{
                      __html: markHighLight(
                        data[`name${array[language]}`],
                        search
                      ),
                    }}
                  >
                    {/* {data[`name${array[language]}`]} */}
                  </span>
                </div>
                <div
                  className="py-1"
                  dangerouslySetInnerHTML={{
                    __html: `<b>${originLabel[language]}</b> : ${markHighLight(
                      data[`region${array[language]}`],
                      search
                    )}`,
                  }}
                >
                  {/* {originLabel[language]} :{" "}
                  {data[`region${array[language]}`]} */}
                </div>
                {/* <div className='py-1'>{categoryLabel[language]} : {data.kind}</div> */}
                <div
                  className="py-1"
                  dangerouslySetInnerHTML={{
                    __html: `<b>${rOrgLabel[language]}</b> : ${markHighLight(
                      data[`regOrg${array[language]}`],
                      search
                    )}`,
                  }}
                >
                  {/* {rOrgLabel[language]} : {data.owner} */}
                </div>
                <div
                  className="py-1"
                  dangerouslySetInnerHTML={{
                    __html: `<b>${rNumberLabel[language]}</b> : ${markHighLight(
                      data.regNo,
                      search
                    )}`,
                  }}
                >
                  {/* {rNumberLabel[language]} : {data.regNo} */}
                </div>
                <div className="py-1">
                  <b>{rDateLabel[language]}</b> :{" "}
                  {moment(data.regDate).format("YYYY-MM-DD")}
                </div>
              </div>
            </div>
            <div>
              <div className="py-2 my-2 h6">
                <b>{introLabel[language]}</b>
              </div>
              <pre
                style={{ whiteSpace: "break-spaces" }}
                dangerouslySetInnerHTML={{
                  __html: processJonham(
                    markHighLight(data[`desc${array[language]}`], search)
                  ),
                }}
              />
            </div>
            <div>
              {data.imageUrls.length != 0 && (
                <>
                  <div className="py-2 my-2 h6">
                    <b>{rImageLabel[language]}</b>
                  </div>
                  <div className="d-flex justify-content-start">
                    {data.imageUrls.slice(0, 4).map((url, index) => (
                      <img
                        key={index}
                        src={`uploads/origin/${url}`}
                        alt={url}
                        style={{ width: "23%", height: "auto" }}
                        className="mx-2"
                      ></img>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div>
              {data.videoUrl != "" && (
                <>
                  <div className="py-2 my-2 h6">
                    <b>{rVideoLabel[language]}</b>
                  </div>
                  <div className="px-2 px-sm-2 px-md-2 px-lg-5 py-3">
                    <video width="100%" controls key={data.videoUrl}>
                      <source
                        src={`uploads/origin/${data.videoUrl}`}
                        type="video/mp4"
                      />
                      Your browser does not support HTML5 video.
                    </video>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.profile.language,
  labels: state.labels,
  search: state.profile.search,
});

export default connect(mapStateToProps, {})(Origins);
